import { Meeting } from '../../../models/chat';
import { ChatMessageInputStore } from '../../../ng-services/chat-message-input.store';
import { ChatUserStatusService } from '../../../ng-services/chat-user-status.service';

(function () {
    class MeetingListItemComponent {
        static $inject = ['MeetingService', 'ChatMessageInputStore', 'ChatUserStatusService'];

        public conversation!: Meeting;
        public isPinned!: boolean;

        public hasDraft = false;

        public isOnline: boolean | null = null;

        get hasOnlineStatus() {
            return this.isOnline !== null;
        }

        constructor(
            private meetingService: any,
            private chatInputStore: ChatMessageInputStore,
            private chatUserStatusService: ChatUserStatusService
        ) {}

        get isUser() {
            return this.conversation.entry === 'user';
        }

        get hasNewMessages() {
            return this.conversation.newMessageCount > 0;
        }

        get newMessageCount(): string {
            const { newMessageCount } = this.conversation;
            return newMessageCount > 9 ? '9+' : '' + newMessageCount;
        }

        get hasMissedCalls() {
            return this.conversation.missedCallsCount > 0;
        }

        get missedCallsCount(): string {
            const { missedCallsCount } = this.conversation;
            return missedCallsCount > 9 ? '9+' : '' + missedCallsCount;
        }

        get canStartCall(): boolean {
            return !!this.conversation.video_conference_url;
        }

        $onInit() {
            this.chatInputStore.hasDraft$(this.conversation).subscribe((v) => {
                this.hasDraft = v;
            });
            this.chatUserStatusService.getStatusForMeeting$(this.conversation).subscribe((isOnline) => {
                if (isOnline === null) {
                    return;
                }
                this.isOnline = Boolean(isOnline);
            });
        }

        startCall() {
            const { conversation } = this;
            if (this.isUser) {
                // If this is a private meeting we should start a Call procedure.
                // It's like you are calling your friend on a Facebook Messenger.
                this.meetingService.startCall(conversation);
                return;
            }

            this.meetingService.joinMeeting(conversation);
        }
    }

    angular.module('tradersyard').component('tyMeetingListItem', {
        // language=HTML
        template: `
            <div class="meeting_list_item"
                 ng-class="{'is-active': $ctrl.isActive, 'is-pinned': $ctrl.isPinned}"
                 ng-click="$ctrl.onActivate($ctrl.conversation)" is-uib>
                <div class="meeting_list_item__avatar">
                    <img ng-src="{{::$ctrl.conversation.thumbnail_url|thumb:80:80}}" alt="">
                    <ty-meeting-list-user-status ng-if="$ctrl.hasOnlineStatus" is-online="$ctrl.isOnline"/>
                </div>
                <div
                    class="meeting_list_item__name"
                    title="{{::$ctrl.conversation.name}}">
                    <span ng-bind-html="$ctrl.conversation.name|highlight : $ctrl.filter"></span>
                </div>
                <div class="meeting_list_item__actions">
                    <div class="meeting_list_item__missed_calls_indicator" ng-if="$ctrl.hasMissedCalls">
                        <i class="fa fa-phone-slash"></i>
                    </div>
                    <div class="meeting_list_item__unread_indicator" ng-if="$ctrl.hasNewMessages">
                        {{$ctrl.newMessageCount}}
                    </div>
                    <i ng-if="$ctrl.hasDraft" class="fa fa-pen meeting_list_item__draft_icon"
                       uib-tooltip="Draft saved"></i>
                    <span ng-click="$ctrl.startCall()" ng-if="$ctrl.canStartCall">
                    <i uib-tooltip="Call friend" class="fa fa-phone" ng-if="$ctrl.isUser"></i>
                    <i uib-tooltip="Join web meeting" class="fa fa-headset" ng-if="!$ctrl.isUser"></i>
                </div>
            </div>
        `,
        bindings: {
            conversation: '<',
            filter: '<',
            onActivate: '<',
            isActive: '<',
            isPinned: '<',
        },
        controller: MeetingListItemComponent,
    });
})();
